import { render } from "./LisansUyariSeridi.vue?vue&type=template&id=777efcb4"
import script from "./LisansUyariSeridi.vue?vue&type=script&lang=js"
export * from "./LisansUyariSeridi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__